import styled from 'styled-components';

const LoadMoreStyled = styled.button`
  height: auto;
  border: none;
  width: 100%;
  color: #fff;
  background: var(--darkBlue);
  text-transform: uppercase;
  outline: 1px solid var(--darkBlue);
  outline-offset: 3px;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 12px;
  margin-bottom: 44px;
  &:hover {
    background: var(--blue);
    color: var(--darkGrey);
  }
`;

const Label = styled.div``;

type Props = {
  clickEvent: () => void;
};

const LoadMore: React.FC<Props> = ({ clickEvent }) => (
  <LoadMoreStyled onClick={() => clickEvent()}>
    <Label>Load More</Label>
  </LoadMoreStyled>
);

export default LoadMore;
